import { post, get } from '@/utils/http.js'
// 算法评分
export const algorithmRating = (data) => { return get('/things/dataAnalysis/algorithmRating', data) }
// 报警概览
export const alarmOverview = (data) => { return get('things/dataAnalysis/alarmOverview', data) }
// 火警数量趋势
export const fireAlarmCountTrend = (data) => { return get('/things/dataAnalysis/fireAlarmCountTrend', data) }
// 水系统监测
export const waterSystemMonitorLine = (data) => { return get('/things/dataAnalysis/waterSystemMonitorLine', data) }
// CRt点位图
export const crtImage = (data) => { return get('/things/dataAnalysis/crtImage', data) }
// 单位各类型设备数量统计
export const deviceCountGroupType = (data) => { return get('/things/dataAnalysis/deviceCountGroupType', data) }
// 综合评分更新
export const comprehensiveScoreUpdate = (data) => { return get('/things/dataAnalysis/comprehensiveScoreUpdate', data) }


